import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { getSettingEnableRetailerExclusivityAgreements } from "@faire/retailer-visitor-shared/settings/getSettingEnableRetailerExclusivityAgreement";
import { QueryParameters } from "@faire/web-api--source/api/exclusivity-agreements/retailers/retailerToken/availability/get";
import { useQuery as useExclusivityAvailabilityQuery } from "@faire/web-api--source/api/exclusivity-agreements/retailers/retailerToken/availability/get-hooks";
/**
 * By default:
 * - Options.enabled = getSettingEnableRetailerExclusivityAgreements()
 * - Options.staleTime = 3 * 60 * 1000
 */ export var useExclusivityAvailability = function(brandToken, options) {
    var _useRetailer = useRetailer(), _useRetailer_retailerToken = _useRetailer.retailerToken, retailerToken = _useRetailer_retailerToken === void 0 ? "" : _useRetailer_retailerToken;
    var _useExclusivityAvailabilityQuery = useExclusivityAvailabilityQuery(retailerToken, QueryParameters.build({
        brand_token: brandToken,
        include_options: true
    }), _object_spread({
        enabled: getSettingEnableRetailerExclusivityAgreements(),
        staleTime: 3 * 60 * 1000
    }, options)), availability = _useExclusivityAvailabilityQuery.data, rest = _object_without_properties(_useExclusivityAvailabilityQuery, [
        "data"
    ]);
    return _object_spread({
        availability: availability
    }, rest);
};
